export const theme = {
  colors: {
    teal: "#008080",
    silver: "#ccc",
    alto: "#ddd",
    white: "#fff",
    crimson: "#db143c",
    japanese: "#0C830C",
    nobel: "#f0f0f0",
    robins: "#05cccc",
    black: "#000000",
  },
  breakpoints: {
    mobile: 767,
  },
};
